import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=0045fced&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0045fced",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0045fced')) {
      api.createRecord('0045fced', component.options)
    } else {
      api.reload('0045fced', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=0045fced&scoped=true&", function () {
      api.rerender('0045fced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eJJdLrnD9b5Y/JS/comp/Accordion.vue"
export default component.exports